export default function ContactIntro() {
  return (
    <>
      <div id='contact-intro' className='banner-image-text'>
        <h1>Get in touch</h1>
        <img
          src="../../images/contact/maidenhead-post-box.jpg"
          alt="Traditional, red, British postbox. Set on grass, with a wooden fence and trees behind it"
          className='full-width-image'
        />
      </div>
      <div className='responsive-text'>
        <h2>Send me a message, and I'll get back to you as soon as I can.</h2>
      </div>
    </>
  );
}